import React, { useMemo, useEffect, useState } from 'react';

/* ────────────────────────────────────────────────────────────────
   Ortak yardımcılar
   ──────────────────────────────────────────────────────────────── */
const rand = (min, max) => min + Math.random() * (max - min);

/* ────────────────────────────────────────────────────────────────
   ❄️ KAR (mevcut) - geriye dönük uyumluluk için yeniden yazıldı
   ──────────────────────────────────────────────────────────────── */
const SnowMode = () => {
  const flakes = useMemo(
    () => Array.from({ length: 55 }, (_, i) => ({
      id: i,
      char: ['❄', '❅', '❆'][i % 3],
      left: rand(0, 100),
      fontSize: rand(10, 28),
      opacity: rand(0.40, 0.90),
      duration: rand(7, 21),
      delay: -rand(0, 20),
      driftX: rand(-90, 90),
      rotateEnd: Math.random() > 0.5 ? 360 : -360,
      blur: Math.random() > 0.6 ? 1 : 0,
    })),
    []
  );

  return (
    <>
      <style>{`
        @keyframes snow-drift {
          0% { transform: translateY(-30px) translateX(0px) rotate(0deg); opacity: 0; }
          8% { opacity: 1; }
          90% { opacity: 0.7; }
          100% { transform: translateY(105vh) translateX(var(--sx)) rotate(var(--sr)); opacity: 0; }
        }
        .snow-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .snow-flake {
          position: absolute; top: 0; user-select: none;
          animation: snow-drift linear infinite;
          text-shadow: 0 0 6px rgba(180,220,255,0.9), 0 0 12px rgba(150,200,255,0.6), 0 0 20px rgba(255,255,255,0.3);
          color: #e8f4ff; will-change: transform;
        }
      `}</style>
      <div className="snow-wrap">
        {flakes.map(f => (
          <div
            key={f.id}
            className="snow-flake"
            style={{
              left: `${f.left}%`,
              fontSize: f.fontSize,
              opacity: f.opacity,
              animationDuration: `${f.duration}s`,
              animationDelay: `${f.delay}s`,
              filter: f.blur ? `blur(${f.blur}px)` : 'none',
              '--sx': `${f.driftX}px`,
              '--sr': `${f.rotateEnd}deg`,
            }}
          >
            {f.char}
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   🎃 CADILAR BAYRAMI - yarasalar + turuncu glow
   ──────────────────────────────────────────────────────────────── */
const HalloweenMode = () => {
  const bats = useMemo(
    () => Array.from({ length: 14 }, (_, i) => ({
      id: i,
      top: rand(5, 75),
      fontSize: rand(18, 36),
      duration: rand(12, 22),
      delay: -rand(0, 15),
      flapSpeed: rand(0.25, 0.55),
      direction: Math.random() > 0.5 ? 1 : -1,
    })),
    []
  );

  const pumpkinDust = useMemo(
    () => Array.from({ length: 22 }, (_, i) => ({
      id: i,
      char: ['🦇', '🕷', '🕸'][i % 3],
      left: rand(0, 100),
      fontSize: rand(8, 14),
      opacity: rand(0.20, 0.45),
      duration: rand(14, 26),
      delay: -rand(0, 18),
    })),
    []
  );

  return (
    <>
      <style>{`
        @keyframes bat-cross {
          0%   { transform: translateX(-12vw) translateY(0px) scaleX(var(--dir)); }
          50%  { transform: translateX(50vw) translateY(-30px) scaleX(var(--dir)); }
          100% { transform: translateX(112vw) translateY(0px) scaleX(var(--dir)); }
        }
        @keyframes bat-flap {
          0%, 100% { transform: scaleY(1); }
          50%      { transform: scaleY(0.55); }
        }
        @keyframes hw-dust-fall {
          0%   { transform: translateY(-20px) rotate(0deg); opacity: 0; }
          10%  { opacity: var(--op); }
          100% { transform: translateY(110vh) rotate(360deg); opacity: 0; }
        }
        @keyframes hw-glow {
          0%, 100% { opacity: 0.55; }
          50%      { opacity: 0.85; }
        }
        .hw-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .hw-glow {
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 60% 35% at 0% 0%,   rgba(251,146,60,0.18) 0%, transparent 60%),
            radial-gradient(ellipse 50% 30% at 100% 100%, rgba(251,146,60,0.16) 0%, transparent 60%),
            radial-gradient(ellipse 70% 40% at 50% 100%, rgba(168,85,247,0.10) 0%, transparent 60%);
          animation: hw-glow 5s ease-in-out infinite;
        }
        .hw-bat {
          position: absolute;
          color: #1a1a2e;
          text-shadow: 0 0 8px rgba(0,0,0,0.6);
          animation: bat-cross linear infinite;
          will-change: transform;
        }
        .hw-bat-inner {
          display: inline-block;
          animation: bat-flap ease-in-out infinite;
        }
        .hw-dust {
          position: absolute; top: 0;
          color: rgba(251,146,60,0.85);
          animation: hw-dust-fall linear infinite;
          will-change: transform;
        }
      `}</style>
      <div className="hw-wrap">
        <div className="hw-glow" />
        {bats.map(b => (
          <div
            key={b.id}
            className="hw-bat"
            style={{
              top: `${b.top}%`,
              fontSize: b.fontSize,
              animationDuration: `${b.duration}s`,
              animationDelay: `${b.delay}s`,
              '--dir': b.direction,
            }}
          >
            <span
              className="hw-bat-inner"
              style={{ animationDuration: `${b.flapSpeed}s` }}
            >
              🦇
            </span>
          </div>
        ))}
        {pumpkinDust.map(d => (
          <div
            key={d.id}
            className="hw-dust"
            style={{
              left: `${d.left}%`,
              fontSize: d.fontSize,
              animationDuration: `${d.duration}s`,
              animationDelay: `${d.delay}s`,
              '--op': d.opacity,
            }}
          >
            {d.char}
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   ❤️ SEVGİLİLER GÜNÜ - kalpler yağar, pembe glow
   ──────────────────────────────────────────────────────────────── */
const ValentineMode = () => {
  const hearts = useMemo(
    () => Array.from({ length: 50 }, (_, i) => ({
      id: i,
      char: ['❤', '💗', '💕', '💖', '💝'][i % 5],
      left: rand(0, 100),
      fontSize: rand(12, 28),
      opacity: rand(0.45, 0.95),
      duration: rand(8, 18),
      delay: -rand(0, 18),
      driftX: rand(-100, 100),
      rotateEnd: rand(-180, 180),
    })),
    []
  );

  return (
    <>
      <style>{`
        @keyframes heart-fall {
          0%   { transform: translateY(-30px) translateX(0px) rotate(0deg) scale(0.6); opacity: 0; }
          10%  { opacity: var(--op); transform: translateY(8vh) translateX(0px) rotate(0deg) scale(1); }
          100% { transform: translateY(108vh) translateX(var(--sx)) rotate(var(--sr)) scale(0.7); opacity: 0; }
        }
        @keyframes vd-glow {
          0%, 100% { opacity: 0.50; }
          50%      { opacity: 0.80; }
        }
        .vd-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .vd-glow {
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 70% 40% at 100% 0%, rgba(244,63,94,0.16) 0%, transparent 60%),
            radial-gradient(ellipse 60% 35% at 0% 100%, rgba(236,72,153,0.14) 0%, transparent 60%);
          animation: vd-glow 4s ease-in-out infinite;
        }
        .vd-heart {
          position: absolute; top: 0; user-select: none;
          color: #ec4899;
          text-shadow: 0 0 10px rgba(236,72,153,0.7), 0 0 18px rgba(244,63,94,0.4);
          animation: heart-fall linear infinite;
          will-change: transform;
        }
      `}</style>
      <div className="vd-wrap">
        <div className="vd-glow" />
        {hearts.map(h => (
          <div
            key={h.id}
            className="vd-heart"
            style={{
              left: `${h.left}%`,
              fontSize: h.fontSize,
              animationDuration: `${h.duration}s`,
              animationDelay: `${h.delay}s`,
              '--sx': `${h.driftX}px`,
              '--sr': `${h.rotateEnd}deg`,
              '--op': h.opacity,
            }}
          >
            {h.char}
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   🍀 ŞANS MODU - yoncalar düşer + altın parıltılar yükselir
   ──────────────────────────────────────────────────────────────── */
const LuckMode = () => {
  const clovers = useMemo(
    () => Array.from({ length: 35 }, (_, i) => ({
      id: i,
      char: ['🍀', '☘'][i % 2],
      left: rand(0, 100),
      fontSize: rand(12, 26),
      opacity: rand(0.50, 0.95),
      duration: rand(10, 20),
      delay: -rand(0, 18),
      driftX: rand(-80, 80),
      rotateEnd: rand(-360, 360),
    })),
    []
  );

  const sparkles = useMemo(
    () => Array.from({ length: 30 }, (_, i) => ({
      id: i,
      left: rand(0, 100),
      fontSize: rand(10, 18),
      duration: rand(6, 14),
      delay: -rand(0, 14),
    })),
    []
  );

  return (
    <>
      <style>{`
        @keyframes clover-fall {
          0%   { transform: translateY(-30px) translateX(0px) rotate(0deg); opacity: 0; }
          10%  { opacity: var(--op); }
          100% { transform: translateY(108vh) translateX(var(--sx)) rotate(var(--sr)); opacity: 0; }
        }
        @keyframes gold-rise {
          0%   { transform: translateY(110vh) scale(0.6); opacity: 0; }
          15%  { opacity: 1; }
          100% { transform: translateY(-30px) scale(1.1); opacity: 0; }
        }
        @keyframes lk-glow {
          0%, 100% { opacity: 0.50; }
          50%      { opacity: 0.85; }
        }
        .lk-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .lk-glow {
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 60% 35% at 50% 0%,   rgba(34,197,94,0.14) 0%, transparent 60%),
            radial-gradient(ellipse 50% 30% at 100% 100%, rgba(250,204,21,0.16) 0%, transparent 60%);
          animation: lk-glow 5s ease-in-out infinite;
        }
        .lk-clover {
          position: absolute; top: 0; user-select: none;
          color: #4ade80;
          text-shadow: 0 0 8px rgba(34,197,94,0.6), 0 0 14px rgba(34,197,94,0.3);
          animation: clover-fall linear infinite;
          will-change: transform;
        }
        .lk-sparkle {
          position: absolute; bottom: 0;
          color: #fcd34d;
          text-shadow: 0 0 8px rgba(250,204,21,0.85), 0 0 14px rgba(250,204,21,0.5);
          animation: gold-rise linear infinite;
          will-change: transform;
        }
      `}</style>
      <div className="lk-wrap">
        <div className="lk-glow" />
        {clovers.map(c => (
          <div
            key={c.id}
            className="lk-clover"
            style={{
              left: `${c.left}%`,
              fontSize: c.fontSize,
              animationDuration: `${c.duration}s`,
              animationDelay: `${c.delay}s`,
              '--sx': `${c.driftX}px`,
              '--sr': `${c.rotateEnd}deg`,
              '--op': c.opacity,
            }}
          >
            {c.char}
          </div>
        ))}
        {sparkles.map(s => (
          <div
            key={`s-${s.id}`}
            className="lk-sparkle"
            style={{
              left: `${s.left}%`,
              fontSize: s.fontSize,
              animationDuration: `${s.duration}s`,
              animationDelay: `${s.delay}s`,
            }}
          >
            ✦
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   🎆 YILBAŞI / HAVAİ FİŞEK - rastgele konumlarda patlamalar
   ──────────────────────────────────────────────────────────────── */
const FireworksMode = () => {
  const [bursts, setBursts] = useState([]);

  useEffect(() => {
    let nextId = 0;
    const colors = ['#fbbf24', '#f87171', '#60a5fa', '#a78bfa', '#4ade80', '#f0abfc', '#fcd34d'];
    const fire = () => {
      const id = nextId++;
      const burst = {
        id,
        left: rand(10, 90),
        top: rand(15, 60),
        color: colors[Math.floor(Math.random() * colors.length)],
        particles: Array.from({ length: 24 }, (_, i) => ({
          angle: (i / 24) * 360,
          distance: rand(60, 120),
        })),
      };
      setBursts(prev => [...prev, burst]);
      setTimeout(() => {
        setBursts(prev => prev.filter(b => b.id !== id));
      }, 1400);
    };

    fire();
    const interval = setInterval(fire, 1100);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <style>{`
        @keyframes fw-particle {
          0%   { transform: translate(0, 0) scale(1); opacity: 1; }
          100% { transform: translate(var(--tx), var(--ty)) scale(0.2); opacity: 0; }
        }
        @keyframes fw-flash {
          0%   { transform: scale(0.2); opacity: 0.9; }
          100% { transform: scale(2.6); opacity: 0; }
        }
        .fw-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .fw-burst {
          position: absolute;
          width: 0; height: 0;
        }
        .fw-flash {
          position: absolute; top: -16px; left: -16px;
          width: 32px; height: 32px; border-radius: 50%;
          background: var(--c);
          filter: blur(6px);
          animation: fw-flash 0.45s ease-out forwards;
        }
        .fw-particle {
          position: absolute;
          width: 5px; height: 5px;
          border-radius: 50%;
          background: var(--c);
          box-shadow: 0 0 8px var(--c), 0 0 14px var(--c);
          animation: fw-particle 1.3s cubic-bezier(0.18, 0.89, 0.32, 1.28) forwards;
        }
      `}</style>
      <div className="fw-wrap">
        {bursts.map(b => (
          <div
            key={b.id}
            className="fw-burst"
            style={{ left: `${b.left}%`, top: `${b.top}%`, '--c': b.color }}
          >
            <div className="fw-flash" style={{ '--c': b.color }} />
            {b.particles.map((p, i) => (
              <div
                key={i}
                className="fw-particle"
                style={{
                  '--c': b.color,
                  '--tx': `${Math.cos((p.angle * Math.PI) / 180) * p.distance}px`,
                  '--ty': `${Math.sin((p.angle * Math.PI) / 180) * p.distance}px`,
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   🌙 RAMAZAN/BAYRAM - hilal + minik yıldızlar, sıcak altın glow
   ──────────────────────────────────────────────────────────────── */
const RamadanMode = () => {
  const stars = useMemo(
    () => Array.from({ length: 60 }, (_, i) => ({
      id: i,
      top: rand(0, 100),
      left: rand(0, 100),
      size: rand(2, 5),
      duration: rand(2, 5),
      delay: -rand(0, 5),
      opacity: rand(0.40, 1.0),
    })),
    []
  );

  const crescents = useMemo(
    () => Array.from({ length: 6 }, (_, i) => ({
      id: i,
      left: rand(5, 92),
      fontSize: rand(22, 42),
      duration: rand(28, 50),
      delay: -rand(0, 30),
      drift: rand(-40, 40),
    })),
    []
  );

  return (
    <>
      <style>{`
        @keyframes star-twinkle {
          0%, 100% { opacity: var(--op); transform: scale(1); }
          50%      { opacity: 0.20;       transform: scale(1.4); }
        }
        @keyframes crescent-drift {
          0%   { transform: translateY(-12vh) translateX(0px); opacity: 0; }
          15%  { opacity: 0.85; }
          85%  { opacity: 0.85; }
          100% { transform: translateY(112vh) translateX(var(--dx)); opacity: 0; }
        }
        @keyframes rm-glow {
          0%, 100% { opacity: 0.55; }
          50%      { opacity: 0.85; }
        }
        .rm-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .rm-glow {
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 70% 45% at 50% 100%, rgba(252,211,77,0.14) 0%, transparent 60%),
            radial-gradient(ellipse 60% 35% at 80% 0%,   rgba(251,146,60,0.10) 0%, transparent 60%);
          animation: rm-glow 6s ease-in-out infinite;
        }
        .rm-star {
          position: absolute; border-radius: 50%;
          background: #fde68a;
          box-shadow: 0 0 6px rgba(252,211,77,0.85), 0 0 12px rgba(252,211,77,0.5);
          animation: star-twinkle ease-in-out infinite;
        }
        .rm-crescent {
          position: absolute; top: 0;
          color: #fcd34d;
          text-shadow: 0 0 12px rgba(252,211,77,0.6), 0 0 24px rgba(252,211,77,0.35);
          animation: crescent-drift linear infinite;
          will-change: transform;
        }
      `}</style>
      <div className="rm-wrap">
        <div className="rm-glow" />
        {stars.map(s => (
          <div
            key={s.id}
            className="rm-star"
            style={{
              top: `${s.top}%`,
              left: `${s.left}%`,
              width: s.size,
              height: s.size,
              opacity: s.opacity,
              animationDuration: `${s.duration}s`,
              animationDelay: `${s.delay}s`,
              '--op': s.opacity,
            }}
          />
        ))}
        {crescents.map(c => (
          <div
            key={c.id}
            className="rm-crescent"
            style={{
              left: `${c.left}%`,
              fontSize: c.fontSize,
              animationDuration: `${c.duration}s`,
              animationDelay: `${c.delay}s`,
              '--dx': `${c.drift}px`,
            }}
          >
            🌙
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   🐑 KURBAN BAYRAMI - kuzular süzülür, hafif yıldız yağışı
   ──────────────────────────────────────────────────────────────── */
const KurbanBayramiMode = () => {
  const lambs = useMemo(
    () => Array.from({ length: 10 }, (_, i) => ({
      id: i,
      left: rand(8, 92),
      fontSize: rand(22, 32),
      duration: rand(28, 44),
      delay: -rand(0, 35),
      drift: rand(-50, 50),
      rotateEnd: rand(-10, 10),
    })),
    []
  );

  const stars = useMemo(
    () => Array.from({ length: 22 }, (_, i) => ({
      id: i,
      left: rand(0, 100),
      fontSize: rand(8, 14),
      opacity: rand(0.35, 0.75),
      duration: rand(12, 22),
      delay: -rand(0, 18),
      driftX: rand(-40, 40),
    })),
    []
  );

  return (
    <>
      <style>{`
        @keyframes kb-lamb-fall {
          0%   { transform: translateY(-15vh) translateX(0px) rotate(0deg); opacity: 0; }
          10%  { opacity: 0.95; }
          90%  { opacity: 0.95; }
          100% { transform: translateY(112vh) translateX(var(--dx)) rotate(var(--rot)); opacity: 0; }
        }
        @keyframes kb-star-fall {
          0%   { transform: translateY(-20px) translateX(0px); opacity: 0; }
          15%  { opacity: var(--op); }
          100% { transform: translateY(110vh) translateX(var(--sx)); opacity: 0; }
        }
        .kb-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .kb-lamb {
          position: absolute; top: 0;
          filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.30));
          animation: kb-lamb-fall linear infinite;
          will-change: transform;
        }
        .kb-star {
          position: absolute; top: 0;
          color: #fde68a;
          text-shadow: 0 0 6px rgba(252, 211, 77, 0.85), 0 0 12px rgba(252, 211, 77, 0.45);
          animation: kb-star-fall linear infinite;
          will-change: transform;
        }
      `}</style>
      <div className="kb-wrap">
        {lambs.map((l) => (
          <div
            key={l.id}
            className="kb-lamb"
            style={{
              left: `${l.left}%`,
              fontSize: l.fontSize,
              animationDuration: `${l.duration}s`,
              animationDelay: `${l.delay}s`,
              '--dx': `${l.drift}px`,
              '--rot': `${l.rotateEnd}deg`,
            }}
          >
            🐑
          </div>
        ))}
        {stars.map((s) => (
          <div
            key={`st-${s.id}`}
            className="kb-star"
            style={{
              left: `${s.left}%`,
              fontSize: s.fontSize,
              animationDuration: `${s.duration}s`,
              animationDelay: `${s.delay}s`,
              '--sx': `${s.driftX}px`,
              '--op': s.opacity,
            }}
          >
            ✦
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   ⚽ MAÇ GÜNÜ - konfeti + ara sıra futbol topu / kupa
   ──────────────────────────────────────────────────────────────── */
const MatchDayMode = () => {
  const colors = ['#ef4444', '#3b82f6', '#fbbf24', '#22c55e', '#a855f7', '#f97316', '#06b6d4'];

  const confetti = useMemo(
    () => Array.from({ length: 70 }, (_, i) => ({
      id: i,
      left: rand(0, 100),
      width: rand(5, 10),
      height: rand(8, 16),
      color: colors[i % colors.length],
      duration: rand(5, 12),
      delay: -rand(0, 12),
      driftX: rand(-100, 100),
      rotateEnd: rand(360, 1080) * (Math.random() > 0.5 ? 1 : -1),
    })),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const symbols = useMemo(
    () => Array.from({ length: 12 }, (_, i) => ({
      id: i,
      char: ['⚽', '🏆', '🥇'][i % 3],
      left: rand(0, 100),
      fontSize: rand(18, 32),
      duration: rand(10, 18),
      delay: -rand(0, 16),
      driftX: rand(-80, 80),
    })),
    []
  );

  return (
    <>
      <style>{`
        @keyframes confetti-fall {
          0%   { transform: translateY(-20px) translateX(0px) rotate(0deg); opacity: 0; }
          10%  { opacity: 1; }
          100% { transform: translateY(108vh) translateX(var(--sx)) rotate(var(--sr)); opacity: 0.85; }
        }
        @keyframes symbol-fall {
          0%   { transform: translateY(-30px) translateX(0px) rotate(0deg); opacity: 0; }
          10%  { opacity: 1; }
          100% { transform: translateY(108vh) translateX(var(--sx)) rotate(360deg); opacity: 0.7; }
        }
        @keyframes md-glow {
          0%, 100% { opacity: 0.55; }
          50%      { opacity: 0.85; }
        }
        .md-wrap { position: fixed; inset: 0; pointer-events: none; z-index: 9990; overflow: hidden; }
        .md-glow {
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 60% 35% at 0% 0%,    rgba(34,197,94,0.10) 0%, transparent 60%),
            radial-gradient(ellipse 60% 35% at 100% 100%, rgba(59,130,246,0.10) 0%, transparent 60%);
          animation: md-glow 5s ease-in-out infinite;
        }
        .md-confetti {
          position: absolute; top: 0;
          border-radius: 1px;
          animation: confetti-fall linear infinite;
          will-change: transform;
        }
        .md-symbol {
          position: absolute; top: 0;
          text-shadow: 0 0 10px rgba(255,255,255,0.4), 0 0 18px rgba(0,0,0,0.5);
          animation: symbol-fall linear infinite;
          will-change: transform;
        }
      `}</style>
      <div className="md-wrap">
        <div className="md-glow" />
        {confetti.map(c => (
          <div
            key={c.id}
            className="md-confetti"
            style={{
              left: `${c.left}%`,
              width: c.width,
              height: c.height,
              background: c.color,
              animationDuration: `${c.duration}s`,
              animationDelay: `${c.delay}s`,
              '--sx': `${c.driftX}px`,
              '--sr': `${c.rotateEnd}deg`,
            }}
          />
        ))}
        {symbols.map(s => (
          <div
            key={`sym-${s.id}`}
            className="md-symbol"
            style={{
              left: `${s.left}%`,
              fontSize: s.fontSize,
              animationDuration: `${s.duration}s`,
              animationDelay: `${s.delay}s`,
              '--sx': `${s.driftX}px`,
            }}
          >
            {s.char}
          </div>
        ))}
      </div>
    </>
  );
};

/* ────────────────────────────────────────────────────────────────
   Ana Wrapper - mod string'ine göre doğru efekti render eder
   ──────────────────────────────────────────────────────────────── */
const SeasonalEffect = ({ mode = 'none' }) => {
  switch (mode) {
    case 'snow':       return <SnowMode />;
    case 'halloween':  return <HalloweenMode />;
    case 'valentine':  return <ValentineMode />;
    case 'luck':       return <LuckMode />;
    case 'fireworks':  return <FireworksMode />;
    case 'ramadan':    return <RamadanMode />;
    case 'kurban':     return <KurbanBayramiMode />;
    case 'matchday':   return <MatchDayMode />;
    default:           return null;
  }
};

export default SeasonalEffect;
